<template>
<w-map-popup title="관리대상 검색">
  <div>
    <el-select v-model="searchType" style="width: 90px;" @change="onSearchTypeChange">
      <el-option label="일반장비" value="quick"></el-option>
      <el-option label="연결장비" value="connection"></el-option>
    </el-select>
    <el-input size="mini" v-model="keyword" :placeholder="placeholder" @keyup.enter.native="searchFilter" style="width: calc(100% - 100px);">
      <i class="el-input__icon el-icon-search" slot="suffix" style="cursor: pointer" @click="searchFilter"></i>
    </el-input>
  </div>
  <div :class="$style.table">
    <el-table
      :data="searchList"
      height="100%"
      style="width: 100%"
      class="popup"
      v-loading="isLoading"
      >
      <el-table-column
        v-for="column in columns"
        :key="column.prop"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :align="column.align"
        :show-overflow-tooltip="true"
        >
        <template slot-scope="scope">
          <i class="el-icon-location" v-if="column.scopedSlot === 'move'" size="small" style="cursor: pointer" @click="clickMapMoveBtn(scope.row, $event)"></i>
          <span v-else-if="isEmpty(column.scopedSlot)">{{scope.row[column.prop]}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</w-map-popup>
</template>

<script>
import MapAPI from '@/api/topologymap/common';

import MapConst from '@/constants/topologymap';

import Base from '@/mixins/topologymap/base';

import WMapPopup from '@/views/topologymap/components/MapPopup';
import { MapInfo } from '@/views/topologymap/js/maps';
import { isEmpty } from '@/utils/basic';

const defaultColumns = [{
  prop: 'objName',
  label: '장비명',
  sortable: false,
  align: 'left',
},
{
  prop: 'ipaddress',
  label: 'IP',
  sortable: false,
  align: 'left',
  width: 150,
},
{
  prop: 'otherMap',
  label: '이동',
  width: 60,
  scopedSlot: 'move',
  sortable: false,
  align: 'center',
}];
const connectColumns = [{
  prop: 'objName',
  label: '장비명',
  sortable: false,
  align: 'left',
  // width: 120,
},
{
  prop: 'ipaddress',
  label: 'IP',
  sortable: false,
  align: 'left',
  width: 120,
},
{
  prop: 'macaddress',
  label: 'MAC',
  sortable: false,
  align: 'left',
  width: 140,
},
{
  prop: 'host',
  label: '호스트',
  sortable: false,
  align: 'left',
},
{
  prop: 'otherMap',
  label: '이동',
  width: 60,
  scopedSlot: 'move',
  sortable: false,
  align: 'center',
}];

export default {
  name: 'WObjectSearchWindow',
  components: {
    WMapPopup,
  },
  mixins: [Base],
  data() {
    return {
      searchType: 'quick',
      /**
       * 팝업 속성
       */
      config: {
        type: MapConst.POPUP_TYPE.WINDOW,
        x: window.innerWidth - 680,
        y: 95,
        width: 520,
        height: 500,
        minWidth: 520,
        minHeight: 500,
        clickToClose: false,
        scrollable: true,
        resizable: true,
        draggable: '.popup-header',
      },
      events: {
        hidden(evt) {
          const thisPopup = evt.popup;
          thisPopup.searchList = [];
          thisPopup.keyword = '';
          thisPopup.searchType = 'quick';
        },
      },
      isLoading: false,
      columns: defaultColumns,
      keyword: '',
      searchList: [],
      showSearchTool: false,
      isEmpty,
    };
  },
  computed: {
    placeholder() {
      return this.searchType === 'quick' ? '장비명, IP 검색' : '장비명, IP, MAC 검색';
    },
  },
  methods: {
    onSearchTypeChange() {
      this.columns = this.searchType === 'quick' ? defaultColumns : connectColumns;
      this.searchList = [];
    },
    searchFilter() {
      if (this.keyword === '') {
        this.searchList = [];
        return;
      }
      this.isLoading = true;
      const condition = this.keyword;
      const type = this.searchType;
      MapAPI.getSearchObject2(condition, type).then((response) => {
        this.searchList = response.data.data;
        this.isLoading = false;
      });
    },
    clickMapMoveBtn(rowData, event) {
      let param = {};
      if (this.searchType === 'connection') {
        param = {
          objId: rowData.hostObjId,
          connectInfoParam: {
            ipaddress: rowData.ipaddress,
            macaddress: rowData.macaddress,
          },
        };
      } else {
        param = {
          objId: rowData.objId,
        };
      }

      MapInfo.getInstance(this).getToolbar().showMapListMenu(event, param);
    },
  },
};
</script>

<style module>
.table {
  width: 100%;
  height: calc(100% - 50px);
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/ObjectSearchWindow.vue